import { mapState } from 'vuex';

export default {
    computed: mapState({
        isEditable: state => state.epiContext.isEditable
    })
};
